import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { CoreApiService } from '../../../core/service/core-api-service';
import { AppService } from '../../../core/service/app.service';
import { properties } from '../../../../environments/properties';
import {
  FOOD_ORDER_STATUS_CONFIG,
  FoodOrderStatusConfig,
  FoodOrderStatusEnum,
  TERMINAL_FOOD_ORDER_STATUS_IDS,
} from '../../../model/food-order-status.model';

@Component({
  selector: 'app-food-order-history',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TableModule,
    ButtonModule,
    DropdownModule,
    TagModule,
    TooltipModule,
    CalendarModule,
  ],
  templateUrl: './food-order-history.component.html',
  styleUrl: './food-order-history.component.css',
})
export class FoodOrderHistoryComponent implements OnInit {
  titulo = 'Historial de Pedidos';
  orders: any[] = [];
  selectedStatusId: number | null = null;
  dateStart: Date;
  dateEnd: Date;
  statusOptions = [
    { label: 'Todos', value: null },
    ...Object.values(FOOD_ORDER_STATUS_CONFIG)
      .filter((config) => TERMINAL_FOOD_ORDER_STATUS_IDS.includes(config.statusId))
      .map((config) => ({
        label: config.name,
        value: config.statusId,
      })),
  ];

  constructor(
    private readonly apiService: CoreApiService,
    private readonly util: AppService,
  ) {
    const end = new Date();
    const start = new Date(end);
    start.setDate(start.getDate() - 10);

    this.dateStart = start;
    this.dateEnd = end;
  }

  ngOnInit(): void {
    this.loadOrders();
  }

  getStatusConfig(order: any): FoodOrderStatusConfig | undefined {
    return FOOD_ORDER_STATUS_CONFIG[order.statusId as FoodOrderStatusEnum];
  }

  formatOrderCode(orderId: number): string {
    return `000-${orderId.toString().padStart(3, '0')}`;
  }

  loadOrders(): void {
    const normalizedStart = this.startOfDay(this.dateStart);
    const normalizedEnd = this.endOfDay(this.dateEnd);

    if (normalizedStart > normalizedEnd) {
      this.util.mostrarToast(
        'Historial de pedidos',
        'La fecha inicial no puede ser posterior a la fecha final',
        4
      );
      return;
    }

    const statusIds = this.selectedStatusId != null ? [this.selectedStatusId] : TERMINAL_FOOD_ORDER_STATUS_IDS;
    const startDate = this.toLocalTimestamp(normalizedStart);
    const endDate = this.toLocalTimestamp(normalizedEnd);

    this.apiService.consumirWSPost(
      properties.serviceFoodOrdersByStore,
      { data: { statusIds, startDate, endDate }, fecha: new Date(), company: this.util.returnEmpresa() },
      (data) => {
        if (data.estado === properties.codeOK) {
          this.orders = data.data ?? [];
        } else {
          this.util.mostrarToast('Historial de pedidos', 'Error al obtener los pedidos', 4);
        }
      }
    );
  }

  onStatusChange(): void {
    this.loadOrders();
  }

  onDateChange(): void {
    this.loadOrders();
  }

  private startOfDay(date: Date): Date {
    const copy = new Date(date);
    copy.setHours(0, 0, 0, 0);
    return copy;
  }

  private endOfDay(date: Date): Date {
    const copy = new Date(date);
    copy.setHours(23, 59, 59, 999);
    return copy;
  }

  private toLocalTimestamp(date: Date): string {
    const pad = (value: number) => value.toString().padStart(2, '0');

    return (
      `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
      `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    );
  }
}
